import { CheckIcon, ExclamationCircleIcon, TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { deleteData } from "../backend";
import { useModal, WorkflowContext } from "../contexts";
import useUser from "../hooks/useUser";
import { BLOCK_ICON_MAP } from "../utils";
import LoadingModal from "./LoadingModal";

function WorkflowOverviewBlockReview() {
  const isValidBlock = true; // TODO: Check if there are documents in the workflow

  const { openModal, closeModal } = useModal();

  const { t } = useTranslation();
  const history = useHistory();

  const { url } = useRouteMatch();

  const { hasPermission } = useUser();
  const { workflow, mutateWorkflow } = useContext(WorkflowContext);

  function handleOpenBlock() {
    history.push(url + "/approvals")
  }

  async function removeBlock(e: React.MouseEvent) {
    e.stopPropagation();

    try {
      openModal(<LoadingModal title={t("Deleting Block")} subtitle={t("Please wait as this may take a moment.")} />);
      await deleteData(`/workflows/reviews/${workflow.review!.id}/`);
    } catch (error) {
      console.error(error);
    } finally {
      await mutateWorkflow();
      closeModal();
    }
  }

  return (
    <>
      <button className={`relative flex flex-shrink-0 items-center justify-start px-8 py-8 mb-5 bg-white border border-gray-300 cursor-pointer group rounded shadow w-[600px]`} onClick={handleOpenBlock}>
        {isValidBlock
          ? <CheckIcon className="flex-shrink-0 w-6 h-6 mr-8 p-1 bg-green text-white rounded-full" />
          : <ExclamationCircleIcon className="flex-shrink-0 w-6 h-6 mr-8 bg-yellow text-white rounded-full" />
        }
        <img src={BLOCK_ICON_MAP["REVIEW"]} alt="Review icon" className="w-12 h-12 flex-shrink-0 mr-8" />
        <div className="flex flex-col w-full overflow-hidden mr-4">
          <p className="text-sm text-gray-400 whitespace-nowrap overflow-ellipsis overflow-hidden text-start">
            {t("Human in the Loop")}
          </p>
          <h3 className={"font-gilroy font-semibold whitespace-nowrap overflow-ellipsis overflow-hidden text-start " + (isValidBlock ? "text-gray-500" : "text-yellow")}>
            {workflow.team ? t("Request Approvals") : t("Review Documents")}
          </h3>
        </div>
        {hasPermission(workflow.team, "workflows.edit") &&
          <div className="hidden group-hover:flex justify-center items-center text-white w-6 h-6 absolute -top-2 -right-2 bg-gray-400 hover:bg-red rounded-full shadow-md" onClick={removeBlock}>
            <TrashIcon className="w-4 h-4" />
          </div>
        }
      </button>
    </>
  );
}

export default WorkflowOverviewBlockReview;
